<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Carousel With Slidebar</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
  <h2>Customized Carousel options</h2>
  <div class="content__tools-wrap">
    <div class="content__row">
      <label for="carouselTypes" class="content__row-label">carouselTypes</label>
      <select [(ngModel)]="carouselTypes" id="carouselTypes" placeholder="carouselTypes" name="carouselTypes" class="c-input-group__control">
        <ng-container *ngFor="let carouselTypes of carouselTypesList">
          <option [value]="carouselTypes">{{ carouselTypes }}</option>
        </ng-container>
      </select>
      <div class="c-input-check-inline">
        <input id="showPagination" class="c-input-check-inline__input" type="checkbox" name="showPagination"
          [(ngModel)]="showPagination">
        <label for="showPagination" class="c-input-check-inline__label">Show Pagination</label>
      </div>
       <div class="c-input-check-inline">
        <input id="showNavigation" class="c-input-check-inline__input" type="checkbox" name="showNavigation"
          [(ngModel)]="showNavigation">
        <label for="showNavigation" class="c-input-check-inline__label">Show Navigation</label>
      </div>
    </div>
    <ng-container *ngIf="carouselTypes === 'with-swiper'">
      <maced-carousel-with-slidebar [hasSwiper]="true" [showPagination]="showPagination" [showNavigation]="showNavigation" [slidesData]="steps"
      [activeStep] = "activeStep" (activeTabEvent)="activeTabEvent($event)" [showSlidebar]="isDesktopView? true: false">
        <ng-template let-data let-inx='inx' #sliderBody>
          <button (click)="selectStep(inx)" role="listitem" [class.active]="inx === activeStep" [attr.aria-current]="inx === activeStep" class="c-slider__sidebar-wrapper-tab">
            <span class="c-slider__sidebar-wrapper-tab-number">{{data.id}} </span>
            <span class="c-slider__sidebar-wrapper-tab-name">{{data.unitTitle}} </span>
          </button>
        </ng-template>
        <ng-template let-data let-inx='inx' #carouselSliderBody>          
          <maced-global-card cardId="sampleCard3" cardName="sampleCardName3">
            <div class="slider-card">
              <div class="slider-card__figure">
                <img class="slider-card__figure-image" [attr.width]="346" [attr.height]="434" src="assets/images/slider-banner.jpg" [alt]="data.title" />
              </div>
               <div class="slider-card__content">
                <div *ngIf="!isDesktopView" class="slider-card__content-number">{{ data.id }}</div>
                <h2 class="slider-card__content-title">Start the lesson</h2>
                <p class="slider-card__content-details">Your next lesson helps learners jump right back to where they left off.<br/>
                  Whether learners are continuing their progress or picking up after a break, this feature makes it easy to resume their practice without searching or navigating through units.</p>
               </div>
            </div>
          </maced-global-card>
        </ng-template>
      </maced-carousel-with-slidebar>
    </ng-container>

    <ng-container *ngIf="carouselTypes === 'swiper-without-slidebar'">
      <maced-carousel-with-slidebar [hasSwiper]="true" [showPagination]="showPagination" [showNavigation]="showNavigation" [slidesData]="steps"
      [activeStep] = "activeStep" (activeTabEvent)="activeTabEvent($event)" [showSlidebar]="false" slidesPerView="3">
        <ng-template let-data let-inx='inx' #carouselSliderBody>        
          <maced-global-card cardId="sampleCard3" cardName="sampleCardName3">
            <div class="slider-card">
              <div class="slider-card__figure">
                <img class="slider-card__figure-image" src="assets/images/slider-banner.jpg" [alt]="data.title" />
              </div>
              <div class="slider-card__content">
                <!-- <div class="slider-card__content-number">{{ data.id }}</div> -->
                <h2 class="slider-card__content-title">Start the lesson</h2>
                <p class="slider-card__content-details">Your next lesson helps learners jump right back to where they left
                  off.<br />
                  Whether learners are continuing their progress or picking up after a break, this feature makes it easy to
                  resume their practice without searching or navigating through units.</p>
              </div>
            </div>
          </maced-global-card>
        </ng-template>
      </maced-carousel-with-slidebar>       
    </ng-container>

    <ng-container *ngIf="carouselTypes === 'without-swiper'">
      <maced-carousel-with-slidebar [hasSwiper]="false" [showPagination]="showPagination" [showNavigation]="showNavigation"
       [slidesData]="steps" [activeStep] = "activeStep" (activeTabEvent)="activeTabEvent($event)" [showSlidebar]="isDesktopView? true: false">
        <ng-template let-data let-inx='inx' #sliderBody>
          <button (click)="selectStep(inx)" role="listitem" class="c-slider__sidebar-wrapper-tab" [class.active]="inx === activeStep">
            <span class="c-slider__sidebar-wrapper-tab-number">{{data.id}} </span>
            <span class="c-slider__sidebar-wrapper-tab-name">{{data.unitTitle}} </span>
          </button>
        </ng-template>
        <ng-template let-data let-inx='inx' #carouselSliderBody>
            <maced-global-card cardId="sampleCard3" cardName="sampleCardName3">
            <div class="slider-card">
              <div class="slider-card__figure">
                <img class="slider-card__figure-image" src="assets/images/slider-banner.jpg" [attr.width]="346" [attr.height]="434" [alt]="data.title" />
              </div>
               <div class="slider-card__content">
                <div *ngIf="!isDesktopView" class="slider-card__content-number">{{ data.id }}</div>
                <h2 class="slider-card__content-title">Start the lesson</h2>
                <p class="slider-card__content-details">Your next lesson helps learners jump right back to where they left off.<br/>
                  Whether learners are continuing their progress or picking up after a break, this feature makes it easy to resume their practice without searching or navigating through units.</p>
               </div>
            </div>
          </maced-global-card>
        </ng-template>
      </maced-carousel-with-slidebar>
    </ng-container>
  </div>
</div>
